import { logger } from 'src/lib/logger'

export const adjustScrollLastMessage = ({
  behavior = 'smooth',
  block = 'start',
  timeout = 0,
}: {
  behavior?: 'smooth' | 'instant'
  block?: 'start' | 'end'
  timeout?: number
}) => {
  const messageElements = document.getElementsByClassName('thread-message')
  const lastMessageElement = messageElements[messageElements.length - 1]

  logger.dev('adjustScrollLastMessage', {
    lastMessageElement: lastMessageElement?.innerText,
    top: lastMessageElement?.getBoundingClientRect().top,
    bottom: lastMessageElement?.getBoundingClientRect().bottom,
  })
  if (lastMessageElement) {
    setTimeout(() => {
      lastMessageElement.scrollIntoView({ behavior, block, inline: 'nearest' })
    }, timeout)
  }
}
